import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerPrint = styled.div`
  display: flex;
  flex-direction: row;
`;
